"use client";
import { FC } from "react";
import {
  // useRouter,
  useSearchParams,
  usePathname,
} from "next/navigation";
import { Button } from "../Button";
import { useSearchResults } from "./SWDCInternalSearchWrapper";

export type CategoryFacet = {
  categoryId: string;
  displayName: string;
  count: number;
  calculationPriority: number;
};

type SWDCInternalSearchLeftFilterProps = {
  showAllCategoriesText?: string;
};

export const SWDCInternalSearchLeftFilter: FC<
  SWDCInternalSearchLeftFilterProps
> = ({ showAllCategoriesText }) => {
  // const router = useRouter();
  const searchParams = useSearchParams();
  const pathname = usePathname();

  const { categories, searchQuery } = useSearchResults();
  const selectedCategory = searchParams?.get("c") || "";

  const handleCategoryClick = (categoryId: string) => {
    if (categoryId === selectedCategory) {
      return;
    }

    const params = new URLSearchParams(searchParams?.toString() || "");
    params.set("c", categoryId);
    params.delete("page");

    const queryString = params.toString();
    const url = queryString ? `${pathname}?${queryString}` : pathname;

    // router.push preserves state, resulting in two `main` elements
    // see https://nextjs.org/docs/app/guides/preserving-ui-state
    // wait until Next provides opt-out strategies
    // router.push(url);
    // eslint-disable-next-line react-hooks/immutability
    location.href = url;
  };

  const handleShowAllCategories = () => {
    const params = new URLSearchParams(searchParams?.toString() || "");
    params.delete("c");
    params.delete("page");
    const queryString = params.toString();
    const url = queryString ? `${pathname}?${queryString}` : pathname;
    // router.push preserves state, resulting in two `main` elements
    // see https://nextjs.org/docs/app/guides/preserving-ui-state
    // wait until Next provides opt-out strategies
    // router.push(url);
    location.href = url;
  };

  // Hide filter when no search query
  if (!searchQuery) {
    return null;
  }

  // Hide filter when no categories available
  if (categories.length === 0) {
    return null;
  }

  const selectedCategoryData = categories.find(
    (cat) => cat.categoryId === selectedCategory,
  );

  return (
    <div className="bg-background-highlight mr-10 flex w-full shrink-0 flex-col gap-4 p-6 lg:w-100">
      {selectedCategoryData ? (
        <>
          <div className="flex flex-col gap-2">
            <Button
              variant="tertiary"
              icon="none"
              className="justify-start text-left"
              onClick={() =>
                handleCategoryClick(selectedCategoryData.categoryId)
              }
            >
              {selectedCategoryData.displayName} ({selectedCategoryData.count})
            </Button>

            <Button
              className="mt-4 shrink-0 text-left underline hover:no-underline!"
              variant="tertiary"
              icon="none"
              onClick={handleShowAllCategories}
            >
              {showAllCategoriesText}
            </Button>
          </div>
        </>
      ) : (
        <>
          {categories.map((category) => (
            <Button
              variant="tertiary"
              key={category.categoryId}
              icon="none"
              className="text-left"
              onClick={() => handleCategoryClick(category.categoryId)}
            >
              {category.displayName} ({category.count})
            </Button>
          ))}
        </>
      )}
    </div>
  );
};
